class User {
    CanViewInvoice: boolean = false;
    CanPayInvoice: boolean = false;

    constructor(init?: Partial<User>) {
        Object.assign(this, init);
    }
}

export default User;